const HEADERS = [
  'Name',
  'Email',
  'Phone',
  'Event Date',
  'Event Location',
  'Event Type',
  'Guest Count',
  'Package',
  'Add-ons',
  'Total Amount (AUD)',
  'Booking Status',
  'Media Consent',
  'Additional Notes',
  'Enquiry Received',
];

const escapeCsvField = (val) => {
  if (val === null || val === undefined) return '';
  const str = String(val);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const rowFromBooking = (b) => {
  const total = b.quote?.total_amount ?? '';
  const addonsList = b.quote?.addons?.map((a) => a.name).join('; ') || '';
  return [
    b.name,
    b.email,
    b.phone,
    b.event_date,
    b.event_location,
    b.event_type || '',
    b.guest_count || '',
    b.quote?.package_name || b.package,
    addonsList,
    total,
    b.status,
    b.media_consent ? 'Granted' : 'Not Given',
    b.additional_notes || '',
    b.created_at ? new Date(b.created_at).toLocaleString('en-AU') : '',
  ];
};

export const exportBookingsToCsv = (bookings, filenamePrefix = 'shot-to-the-nines-bookings') => {
  if (!bookings?.length) return false;

  const rows = [HEADERS, ...bookings.map(rowFromBooking)];
  const csv = rows.map((row) => row.map(escapeCsvField).join(',')).join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  const timestamp = new Date().toISOString().slice(0, 10);
  link.href = url;
  link.download = `${filenamePrefix}-${timestamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return true;
};
